import { render, staticRenderFns } from "./ProductTypeListView.vue?vue&type=template&id=a94fd170&scoped=true"
import script from "./ProductTypeListView.vue?vue&type=script&lang=js"
export * from "./ProductTypeListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94fd170",
  null
  
)

export default component.exports